var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import createStringMapSerializers from '../common/createStringMapSerializers';
import { JsonConverter, JsonObject, JsonProperty } from 'json2typescript';
export var BypassServiceChangeValue;
(function (BypassServiceChangeValue) {
    BypassServiceChangeValue["DestructiveChangeNotAllowed"] = "DestructiveChangeNotAllowed";
    BypassServiceChangeValue["InvalidSyncSchema"] = "InvalidSyncSchema";
    BypassServiceChangeValue["SyncProtocolIncrease"] = "SyncProtocolVersionIncrease";
    BypassServiceChangeValue["DestructiveSyncProtocolIncrease"] = "DestructiveSyncProtocolVersionIncrease";
})(BypassServiceChangeValue || (BypassServiceChangeValue = {}));
var SyncClientSchemaAlert = (function () {
    function SyncClientSchemaAlert(partial) {
        this.errorCode = '';
        this.error = '';
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('error_code'),
        __metadata("design:type", Object)
    ], SyncClientSchemaAlert.prototype, "errorCode", void 0);
    __decorate([
        JsonProperty('error'),
        __metadata("design:type", Object)
    ], SyncClientSchemaAlert.prototype, "error", void 0);
    SyncClientSchemaAlert = __decorate([
        JsonObject('SyncClientSchemaAlert'),
        __metadata("design:paramtypes", [Object])
    ], SyncClientSchemaAlert);
    return SyncClientSchemaAlert;
}());
export { SyncClientSchemaAlert };
var SyncClientSchema = (function () {
    function SyncClientSchema(partial) {
        this.serviceId = '';
        this.ruleId = '';
        this.schemaId = '';
        this.collectionDisplayName = '';
        this.modelName = '';
        this.importStatements = [];
        this.schema = '';
        this.warnings = [];
        this.error = new SyncClientSchemaAlert();
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('service_id'),
        __metadata("design:type", Object)
    ], SyncClientSchema.prototype, "serviceId", void 0);
    __decorate([
        JsonProperty('rule_id'),
        __metadata("design:type", Object)
    ], SyncClientSchema.prototype, "ruleId", void 0);
    __decorate([
        JsonProperty('schema_id'),
        __metadata("design:type", Object)
    ], SyncClientSchema.prototype, "schemaId", void 0);
    __decorate([
        JsonProperty('collection_display_name'),
        __metadata("design:type", Object)
    ], SyncClientSchema.prototype, "collectionDisplayName", void 0);
    __decorate([
        JsonProperty('model_name'),
        __metadata("design:type", Object)
    ], SyncClientSchema.prototype, "modelName", void 0);
    __decorate([
        JsonProperty('import_statements'),
        __metadata("design:type", Array)
    ], SyncClientSchema.prototype, "importStatements", void 0);
    __decorate([
        JsonProperty('schema'),
        __metadata("design:type", Object)
    ], SyncClientSchema.prototype, "schema", void 0);
    __decorate([
        JsonProperty('warnings', [SyncClientSchemaAlert]),
        __metadata("design:type", Array)
    ], SyncClientSchema.prototype, "warnings", void 0);
    __decorate([
        JsonProperty('error', SyncClientSchemaAlert),
        __metadata("design:type", SyncClientSchemaAlert)
    ], SyncClientSchema.prototype, "error", void 0);
    SyncClientSchema = __decorate([
        JsonObject('SyncClientSchema'),
        __metadata("design:paramtypes", [Object])
    ], SyncClientSchema);
    return SyncClientSchema;
}());
export { SyncClientSchema };
var SyncConfig = (function () {
    function SyncConfig(partial) {
        this.developmentModeEnabled = false;
        this.serviceId = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('development_mode_enabled'),
        __metadata("design:type", Object)
    ], SyncConfig.prototype, "developmentModeEnabled", void 0);
    __decorate([
        JsonProperty('service_id', String, true),
        __metadata("design:type", String)
    ], SyncConfig.prototype, "serviceId", void 0);
    SyncConfig = __decorate([
        JsonObject('SyncConfig'),
        __metadata("design:paramtypes", [Object])
    ], SyncConfig);
    return SyncConfig;
}());
export { SyncConfig };
var PartitionField = (function () {
    function PartitionField(partial) {
        this.key = '';
        this.type = '';
        this.required = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('key'),
        __metadata("design:type", Object)
    ], PartitionField.prototype, "key", void 0);
    __decorate([
        JsonProperty('type'),
        __metadata("design:type", Object)
    ], PartitionField.prototype, "type", void 0);
    __decorate([
        JsonProperty('required', Boolean, true),
        __metadata("design:type", Boolean)
    ], PartitionField.prototype, "required", void 0);
    PartitionField = __decorate([
        JsonObject('PartitionField'),
        __metadata("design:paramtypes", [Object])
    ], PartitionField);
    return PartitionField;
}());
export { PartitionField };
var NumCollections = (function () {
    function NumCollections(partial) {
        this.numCollections = 0;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('num_collections'),
        __metadata("design:type", Object)
    ], NumCollections.prototype, "numCollections", void 0);
    NumCollections = __decorate([
        JsonObject('NumCollections'),
        __metadata("design:paramtypes", [Object])
    ], NumCollections);
    return NumCollections;
}());
export { NumCollections };
var AllowedQueryableFields = (function () {
    function AllowedQueryableFields(partial) {
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('queryable_fields'),
        __metadata("design:type", Map)
    ], AllowedQueryableFields.prototype, "queryableFields", void 0);
    AllowedQueryableFields = __decorate([
        JsonObject('AllowedQueryableFields'),
        __metadata("design:paramtypes", [Object])
    ], AllowedQueryableFields);
    return AllowedQueryableFields;
}());
export { AllowedQueryableFields };
var SyncData = (function () {
    function SyncData(partial) {
        this.serviceId = undefined;
        this.partitionFields = undefined;
        this.queryableFieldsNames = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('service_id', String, true),
        __metadata("design:type", String)
    ], SyncData.prototype, "serviceId", void 0);
    __decorate([
        JsonProperty('partition_fields', [PartitionField], true),
        __metadata("design:type", Array)
    ], SyncData.prototype, "partitionFields", void 0);
    __decorate([
        JsonProperty('queryable_fields_names', [String], true),
        __metadata("design:type", Array)
    ], SyncData.prototype, "queryableFieldsNames", void 0);
    SyncData = __decorate([
        JsonObject('SyncData'),
        __metadata("design:paramtypes", [Object])
    ], SyncData);
    return SyncData;
}());
export { SyncData };
export var PartitionKeyType;
(function (PartitionKeyType) {
    PartitionKeyType["String"] = "string";
    PartitionKeyType["ObjectId"] = "objectId";
    PartitionKeyType["Long"] = "long";
    PartitionKeyType["UUID"] = "uuid";
})(PartitionKeyType || (PartitionKeyType = {}));
var PatchSyncSchemasRequest = (function () {
    function PatchSyncSchemasRequest(partial) {
        this.serviceId = '';
        this.partitionKey = '';
        this.partitionKeyType = PartitionKeyType.String;
        this.partitionKeyRequired = undefined;
        this.indexOnPartitionKey = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('service_id'),
        __metadata("design:type", Object)
    ], PatchSyncSchemasRequest.prototype, "serviceId", void 0);
    __decorate([
        JsonProperty('partition_key'),
        __metadata("design:type", Object)
    ], PatchSyncSchemasRequest.prototype, "partitionKey", void 0);
    __decorate([
        JsonProperty('partition_key_type'),
        __metadata("design:type", String)
    ], PatchSyncSchemasRequest.prototype, "partitionKeyType", void 0);
    __decorate([
        JsonProperty('partition_key_required', Boolean, true),
        __metadata("design:type", Boolean)
    ], PatchSyncSchemasRequest.prototype, "partitionKeyRequired", void 0);
    __decorate([
        JsonProperty('index_on_partition_key', Boolean, true),
        __metadata("design:type", Boolean)
    ], PatchSyncSchemasRequest.prototype, "indexOnPartitionKey", void 0);
    PatchSyncSchemasRequest = __decorate([
        JsonObject('PatchSyncSchemasRequest'),
        __metadata("design:paramtypes", [Object])
    ], PatchSyncSchemasRequest);
    return PatchSyncSchemasRequest;
}());
export { PatchSyncSchemasRequest };
var SyncProgressDetails = (function () {
    function SyncProgressDetails(partial) {
        this.startedAt = '';
        this.updatedAt = '';
        this.error = undefined;
        this.documentsCompleted = undefined;
        this.totalDocuments = undefined;
        this.complete = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('started_at'),
        __metadata("design:type", Object)
    ], SyncProgressDetails.prototype, "startedAt", void 0);
    __decorate([
        JsonProperty('updated_at'),
        __metadata("design:type", Object)
    ], SyncProgressDetails.prototype, "updatedAt", void 0);
    __decorate([
        JsonProperty('error', String, true),
        __metadata("design:type", String)
    ], SyncProgressDetails.prototype, "error", void 0);
    __decorate([
        JsonProperty('documents_completed', Number, true),
        __metadata("design:type", Number)
    ], SyncProgressDetails.prototype, "documentsCompleted", void 0);
    __decorate([
        JsonProperty('total_documents', Number, true),
        __metadata("design:type", Number)
    ], SyncProgressDetails.prototype, "totalDocuments", void 0);
    __decorate([
        JsonProperty('complete', Boolean, true),
        __metadata("design:type", Boolean)
    ], SyncProgressDetails.prototype, "complete", void 0);
    SyncProgressDetails = __decorate([
        JsonObject('SyncProgressDetails'),
        __metadata("design:paramtypes", [Object])
    ], SyncProgressDetails);
    return SyncProgressDetails;
}());
export { SyncProgressDetails };
var syncProgressDetailsMapSerializers = createStringMapSerializers(SyncProgressDetails);
var SyncProgressDetailsMapConverter = (function () {
    function SyncProgressDetailsMapConverter() {
        this.serialize = syncProgressDetailsMapSerializers.serialize;
        this.deserialize = syncProgressDetailsMapSerializers.deserialize;
    }
    SyncProgressDetailsMapConverter = __decorate([
        JsonConverter
    ], SyncProgressDetailsMapConverter);
    return SyncProgressDetailsMapConverter;
}());
var SyncProgress = (function () {
    function SyncProgress(partial) {
        this.progress = {};
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('progress', SyncProgressDetailsMapConverter),
        __metadata("design:type", Object)
    ], SyncProgress.prototype, "progress", void 0);
    SyncProgress = __decorate([
        JsonObject('SyncProgress'),
        __metadata("design:paramtypes", [Object])
    ], SyncProgress);
    return SyncProgress;
}());
export { SyncProgress };
//# sourceMappingURL=Sync.js.map